export const MINUTE = 60
export const ONE_DAY = 60 * 60 * 24
export const HALF_HOUR = 30 * 60
export const ONE_HOUR = 60 * 60
export const REFETCH_INTERVAL = ONE_HOUR - 5 * MINUTE
